'use strict'

var scan = require('./scan')
var parse = require('./parse')

module.exports = function (source) {
  return parse(scan(source))
}



//////////////////
// WEBPACK FOOTER
// ./~/spdx-expression-parse/index.js
// module id = 417
// module chunks = 0